import { Theme } from '@mui/material';
import { SxProps } from '@mui/material/styles';

export const getStyles = (): Record<string, SxProps<Theme>> => ({
  image: {
    display: 'flex',
    justifySelf: 'center',
    objectFit: 'cover',
    height: 'auto',
    width: '100%',
    maxWidth: '606px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 5, sm: 6, lg: 9 },
  },
  typography: { hyphens: 'none', wordBreak: 'keep-all' },
});
